import { PERMISSIONS } from '../constants/permissions';
import type { TimePermissionModuleCapabilities } from '../types/timePermission';
import { hasPermission } from '../utils/permissions';

/**
 * Time-permission capabilities from mounted backend routes
 * (arkhrmsapi permission.routes.js).
 *
 * Mounted:
 * - GET /permissions/dashboard, /history, /types, /:id
 * - POST /permissions
 * - POST /permissions/:id/cancel|approve|reject
 */
export const TIME_PERMISSION_ROUTE_CAPABILITIES = {
  dashboard: true,
  history: true,
  details: true,
  apply: true,
  cancel: true,
  types: true,
  adminRequests: true,
  permissionApproval: true,
  approveAction: true,
  rejectAction: true,
} as const;

export function getTimePermissionModuleCapabilities(
  permissions: readonly string[],
): TimePermissionModuleCapabilities {
  const canRead = hasPermission(
    permissions,
    PERMISSIONS.TIME_PERMISSION_VIEW,
  );
  const canApprove = hasPermission(permissions, PERMISSIONS.PERMISSION_APPROVE);
  return {
    canViewHistory: canRead && TIME_PERMISSION_ROUTE_CAPABILITIES.history,
    canViewDetails: (canRead || canApprove) && TIME_PERMISSION_ROUTE_CAPABILITIES.details,
    canApply: canRead && TIME_PERMISSION_ROUTE_CAPABILITIES.apply,
    canCancel: (canRead || canApprove) && TIME_PERMISSION_ROUTE_CAPABILITIES.cancel,
    hasTypeLookup: canRead && TIME_PERMISSION_ROUTE_CAPABILITIES.types,
    canViewAdminRequests:
      canApprove && TIME_PERMISSION_ROUTE_CAPABILITIES.adminRequests,
    canAccessPermissionApproval:
      canApprove && TIME_PERMISSION_ROUTE_CAPABILITIES.permissionApproval,
  };
}
